export { default } from './visually-hidden';
export type { VisuallyHiddenProps } from './types';
